import LaunchIcon from '@mui/icons-material/Launch';
import React from 'react';
import { Link } from 'react-router-dom';
import { FORGE_MASTER_LABEL_PATH } from '../forge/paths';

interface EmbeddingsLinkProps {
  upc: string;
  chainId: number;
  storeId?: number;
  storeName?: string;
  itemNumber?: string;
  variant?: 'button' | 'link';
}

export const EmbeddingsLink: React.FC<EmbeddingsLinkProps> = ({
  upc,
  chainId,
  storeId,
  storeName,
  itemNumber,
  variant = 'button',
}) => {
  const params = new URLSearchParams();
  params.append('chain_id', chainId.toString());

  if (itemNumber) {
    params.append('item_number', itemNumber);
  } else {
    params.append('upc', upc);
  }

  if (storeId) {
    params.append('store_id', storeId.toString());
  }
  if (storeName) {
    params.append('store_name', storeName);
  }

  const className =
    variant === 'link'
      ? 'text-xs text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1'
      : 'inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700 transition-colors';

  const forgeParams = new URLSearchParams();
  forgeParams.set('chain', chainId.toString());

  if (itemNumber) {
    forgeParams.set('in', itemNumber);
  } else if (upc) {
    forgeParams.set('nb', upc);
  }

  return (
    <div className="inline-flex items-center gap-2">
      <Link
        to={`/embeddings/detail?${params.toString()}`}
        target="_blank"
        className={className}
        title="View embeddings for this UPC"
        onClick={(e) => e.stopPropagation()}
      >
        <LaunchIcon sx={{ fontSize: variant === 'link' ? 20 : 12 }} />
        Embeddings
      </Link>
      <Link
        to={`${FORGE_MASTER_LABEL_PATH}?${forgeParams.toString()}`}
        target="_blank"
        className={className}
        title="View in Forge"
        onClick={(e) => e.stopPropagation()}
      >
        <LaunchIcon sx={{ fontSize: variant === 'link' ? 20 : 12 }} />
        Forge
      </Link>
    </div>
  );
};
